import React from 'react';
import './Sidebar.css';

/**
 * Sidebar – collapsible navigation panel
 * @param {object} user - logged-in user (from useAuth)
 * @param {array}  navConfig - role-filtered nav items from useNav
 */
export default function Sidebar({ active, collapsed, mobileOpen, onNavigate, user, navConfig = [] }) {
  const displayUser = user || { name: 'Rajesh Bhagat', role: 'Owner', avatar: 'RB' };

  // Generate avatar initials from name if not provided
  const avatarText = displayUser.avatar ||
    displayUser.name?.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2) || '?';

  return (
    <aside className={`sidebar ${collapsed ? 'sidebar--collapsed' : ''} ${mobileOpen ? 'sidebar--open' : ''}`}>
      <div className="sidebar__accent" />

      {/* Logo */}
      <div className="sidebar__logo">
        <div className="sidebar__logo-icon">🌽</div>
        {!collapsed && (
          <div className="sidebar__logo-text">
            <div className="sidebar__logo-title">Maaze</div>
            <div className="sidebar__logo-sub">Seed Management</div>
          </div>
        )}
      </div>

      {/* Navigation — uses role-filtered navConfig */}
      <nav className="sidebar__nav">
        {navConfig.map((section) => (
          <div key={section.section}>
            <div className="sidebar__section-label">{section.section}</div>
            {section.items.map((item) => (
              <div
                key={item.id}
                className={`sidebar__nav-item ${active === item.id ? 'sidebar__nav-item--active' : ''}`}
                onClick={() => onNavigate(item.id)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && onNavigate(item.id)}
              >
                <span className="sidebar__nav-icon">{item.icon}</span>
                {!collapsed && <span className="sidebar__nav-label">{item.label}</span>}
                {!collapsed && item.badge && <span className="sidebar__nav-badge">{item.badge}</span>}
              </div>
            ))}
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div className="sidebar__footer">
        <div className="sidebar__user">
          <div className="sidebar__avatar">{avatarText}</div>
          {!collapsed && (
            <div className="sidebar__user-info">
              <div className="sidebar__user-name">{displayUser.name}</div>
              <div className="sidebar__user-role">{displayUser.role}</div>
            </div>
          )}
        </div>
      </div>
    </aside>
  );
}
